import React from "react";
import {
  Avatar,
  AvatarGroup,
  Box,
  Folder2Icon,
  FormBuilderIcon,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const GroupAvatar = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Group Avatars
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={2}>
          <Typography variant="body1" fontSize={14}>
            Group Avatars Size
          </Typography>
          <PreviewAndEditor
            language={"js"}
            value={
              '              <AvatarGroup size="small" max={4}>\n' +
              '                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />\n' +
              '                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />\n' +
              '                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />\n' +
              '                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />\n' +
              "                <Avatar\n" +
              '                  alt="Trevor Henderson"\n' +
              '                  src="/static/images/avatar/5.jpg"\n' +
              "                />\n" +
              "              </AvatarGroup>\n" +
              "\n" +
              '              <AvatarGroup size="medium" max={4}>\n' +
              '                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />\n' +
              '                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />\n' +
              '                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />\n' +
              '                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />\n' +
              "                <Avatar\n" +
              '                  alt="Trevor Henderson"\n' +
              '                  src="/static/images/avatar/5.jpg"\n' +
              "                />\n" +
              "              </AvatarGroup>\n" +
              "\n" +
              "              <AvatarGroup max={4}>\n" +
              '                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />\n' +
              '                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />\n' +
              '                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />\n' +
              '                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />\n' +
              "                <Avatar\n" +
              '                  alt="Trevor Henderson"\n' +
              '                  src="/static/images/avatar/5.jpg"\n' +
              "                />\n" +
              "              </AvatarGroup>"
            }
          >
            <Stack alignItems={"center"} spacing={2}>
              <AvatarGroup size="small" max={4}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
                <Avatar
                  alt="Trevor Henderson"
                  src="/static/images/avatar/5.jpg"
                />
              </AvatarGroup>

              <AvatarGroup size="medium" max={4}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
                <Avatar
                  alt="Trevor Henderson"
                  src="/static/images/avatar/5.jpg"
                />
              </AvatarGroup>

              <AvatarGroup max={4}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
                <Avatar
                  alt="Trevor Henderson"
                  src="/static/images/avatar/5.jpg"
                />
              </AvatarGroup>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={2}>
          <Typography variant="body1" fontSize={14}>
            Group Avatars Spacing
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={
              '              <AvatarGroup size="large" spacing={"medium"} max={4}>\n' +
              '                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />\n' +
              '                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />\n' +
              '                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />\n' +
              '                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />\n' +
              "                <Avatar\n" +
              '                  alt="Trevor Henderson"\n' +
              '                  src="/static/images/avatar/5.jpg"\n' +
              "                />\n" +
              "              </AvatarGroup>\n" +
              "\n" +
              '              <AvatarGroup size="large" spacing={"small"} max={4}>\n' +
              "                <Avatar>\n" +
              "                  <FolderIcon />\n" +
              "                </Avatar>\n" +
              "                <Avatar sx={{ bgcolor: pink[500] }}>\n" +
              "                  <PageviewIcon />\n" +
              "                </Avatar>\n" +
              "                <Avatar sx={{ bgcolor: green[500] }}>\n" +
              "                  <AssignmentIcon />\n" +
              "                </Avatar>\n" +
              "                <Avatar>\n" +
              "                  <FolderIcon />\n" +
              "                </Avatar>\n" +
              "                <Avatar sx={{ bgcolor: pink[500] }}>\n" +
              "                  <PageviewIcon />\n" +
              "                </Avatar>\n" +
              "              </AvatarGroup>\n" +
              "\n" +
              '              <AvatarGroup size="large" spacing={5} max={4}>\n' +
              "                <Avatar\n" +
              '                  alt="Remy Sharp"\n' +
              '                  src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"\n' +
              "                />\n" +
              "                <Avatar\n" +
              '                  alt="Travis Howard"\n' +
              '                  src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"\n' +
              "                />\n" +
              "                <Avatar\n" +
              '                  alt="Cindy Baker"\n' +
              '                  src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"\n' +
              "                />\n" +
              "                <Avatar\n" +
              '                  alt="Remy Sharp"\n' +
              '                  src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"\n' +
              "                />\n" +
              "                <Avatar\n" +
              '                  alt="Travis Howard"\n' +
              '                  src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"\n' +
              "                />\n" +
              "              </AvatarGroup>"
            }
          >
            <Stack alignItems={"center"} spacing={2}>
              <AvatarGroup size="large" spacing={"medium"} max={4}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
                <Avatar
                  alt="Trevor Henderson"
                  src="/static/images/avatar/5.jpg"
                />
              </AvatarGroup>

              <AvatarGroup size="large" spacing={"small"} max={4}>
                <Avatar>
                  <Folder2Icon />
                </Avatar>
                <Avatar sx={{ bgcolor: "#e91e63" }}>
                  <FormBuilderIcon />
                </Avatar>
                <Avatar sx={{ bgcolor: "#4caf50" }}>
                  <FormBuilderIcon />
                </Avatar>
                <Avatar>
                  <Folder2Icon />
                </Avatar>
                <Avatar sx={{ bgcolor: "#e91e63" }}>
                  <FormBuilderIcon />
                </Avatar>
              </AvatarGroup>

              <AvatarGroup size="large" spacing={5} max={4}>
                <Avatar
                  alt="Remy Sharp"
                  src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
                />
                <Avatar
                  alt="Travis Howard"
                  src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
                />
                <Avatar
                  alt="Cindy Baker"
                  src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
                />
                <Avatar
                  alt="Remy Sharp"
                  src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
                />
                <Avatar
                  alt="Travis Howard"
                  src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=580&q=80"
                />
              </AvatarGroup>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default GroupAvatar;
